import { type FC, useMemo } from "react";
import { cn } from "@/components/podkit/lib/cn";

type SvgPreviewProps = {
    content: string;
    className?: string;
};

/**
 * Renders SVG content as a preview using an <img> tag with a data URI.
 * This approach is inherently safe — <img> elements do not execute
 * embedded scripts or load external resources.
 */
export const SvgPreview: FC<SvgPreviewProps> = ({ content, className }) => {
    const dataUri = useMemo(() => {
        const encoded = encodeURIComponent(content);
        return `data:image/svg+xml,${encoded}`;
    }, [content]);

    return (
        <div
            className={cn(
                "flex items-center justify-center rounded-lg border border-border-base bg-surface-secondary p-6",
                className,
            )}
        >
            <img src={dataUri} alt="SVG preview" className="max-h-[600px] max-w-full object-contain" />
        </div>
    );
};
